<template>
    <vs-popup
        class="ccompensate-modal"
        title="Restaurant compenseren"
        :active.sync="showPopup"
        v-if="activeOrder !== null"
    >
        <vs-list>
            <vs-list-item v-for="detail in activeOrder.details" :key="detail.id">
                <template slot="title">
                    <p>
                        <input 
                            type="checkbox"
                            class="boxStyles">
                            <b>{{ detail.quantity }}x</b> 
                            {{detail.product.name}}
                    </p>
                </template>
                <template slot="subtitle">
                    <ul class="pl-4">
                        <li v-for="addon in detail.addons" :key="addon.id">
                            {{ addon.name }}<em v-if="addon.price"> +€ {{ addon.price }}</em>
                        </li>
                    </ul>
                </template>
                € {{ detail.price }}
            </vs-list-item>
        </vs-list>
        <vs-button 
            class="mr-3 w-full mb-2"
            
        >
                Stort alle geselecteerde producten terug
        </vs-button>
    </vs-popup>
</template>

<script>
    export default {
        data() {
            return {
                massActive: false,
                showPopup: false,
                activeOrder: null
            };
        },
        mounted() {
            this.isMounted = true;
            this.$events.listen("open-ccompensate-modal", (order) => {
                this.activeOrder = order; 
                this.showPopup = true;
            });
        },
    };
</script>

<style>
    .boxStyles {
        margin-right: 0.5em;
    }
</style>>